import React from 'react';

import WarningMessage from '../elements/WarningMessage';
import {useWorkspaceBanners} from './useWorkspaceBanners';

export const WorkspaceBanners = () => {
  const {dismissWorkspaceBanner, shouldShowCliVersionWarning} =
    useWorkspaceBanners();
  return (
    <>
      {shouldShowCliVersionWarning && (
        <WarningMessage
          content={
            <p>
              Your version of wandb is outdated. Please upgrade with: pip
              install wandb --upgrade
            </p>
          }
          className="slow-warning"
          onDismiss={() => dismissWorkspaceBanner('cli-version-warning')}
        />
      )}
    </>
  );
};
